import * as React from 'react';
import { SelectListItem } from '../../models/utilities/selectlist-item';
import { InputFeedback } from '../form-elements/InputFeedback';

// #region Component Props 

interface IProps<T> {
    id          : string;
    value       : any;
    onChange    : any;
    classList   : string;
    error       : string;
    name        : string;
    options     : Array<SelectListItem<T>>;
    disabled?   : boolean;
}

// #endregion

export class EditSelectCell<T extends number|string> extends React.Component<IProps<T>> {

    public static defaultProps = {
        disabled: false
    };

    public render() {

        const { id, value, onChange, classList, error, name, options, disabled } = this.props;

        return <td className={'editing-cell ' + classList}>
            <select
                id={id}
                className="form-control"
                value={value ? value : ''}
                name={name}
                disabled={ disabled }
                onChange={onChange}>
                <option id={undefined}>Choose...</option>
                {
                    options.map((itm: SelectListItem<T>) => (
                        <option key={itm.id} value={itm.id}>{itm.name}</option>
                    ))
                }
            </select>
            {
                error ? <InputFeedback error={error} /> : <span />
            }
        </td>;
    }
}
